import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 11 10",
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M2.83325 2.0788C2.83325 1.67415 2.83325 1.47182 2.91762 1.36029C2.99112 1.26313 3.10347 1.20301 3.22508 1.19575C3.36468 1.18741 3.53303 1.29964 3.86972 1.5241L8.2512 4.44509C8.5294 4.63056 8.66851 4.72329 8.71698 4.84018C8.75936 4.94237 8.75936 5.05721 8.71698 5.1594C8.66851 5.27629 8.5294 5.36902 8.2512 5.55449L3.86972 8.47548C3.53303 8.69994 3.36468 8.81217 3.22508 8.80383C3.10347 8.79657 2.99112 8.73645 2.91762 8.63928C2.83325 8.52775 2.83325 8.32543 2.83325 7.92078V2.0788Z",
    stroke: $props.color,
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}